import React from "react";
import Navbar from "../../COMPONENTS/Navbar/Navbar";
import accueil from "../../../ASSETS/tourisme/Image/accueil.png";
import BarresearchP from "../../COMPONENTS/BarreSearchP/BarreSearchP";
import ImgCi from "../../../ASSETS/tourisme/Image/Ci.jpg";
import basilique from "../../../ASSETS/tourisme/Image/baselique.jpg";
import mosque from "../../../ASSETS/tourisme/Image/Mosque.jpg";
import fort from "../../../ASSETS/tourisme/Image/fortDabou.jpg";
import cascade from "../../../ASSETS/tourisme/Image/cascade_man.jpg";
import mario from "../../../ASSETS/tourisme/Image/mario.png";
import quenns from "../../../ASSETS/tourisme/Image/quenns.png";
import laBrise from "../../../ASSETS/tourisme/Image/laBrise.png";
import havana from "../../../ASSETS/tourisme/Image/havana.png";
import voiture from "../../../ASSETS/tourisme/Image/Voiture.jpg";
import voiture2 from "../../../ASSETS/tourisme/Image/voiture2.jpg";
import voiture3 from "../../../ASSETS/tourisme/Image/voiture3.jpg";
import botanique from "../../../ASSETS/tourisme/Image/image_loisirs/botanique.png";
import cecile from "../../../ASSETS/tourisme/Image/image_loisirs/galerieCecile.png";
import cosmos from "../../../ASSETS/tourisme/Image/image_loisirs/cosmos.png";
import mall from "../../../ASSETS/tourisme/Image/image_loisirs/Mall.png";
import paradisia from "../../../ASSETS/tourisme/Image/image_loisirs/paradisia.png";
import musee from "../../../ASSETS/tourisme/Image/image_loisirs/Musée_des_civilisations1.png";
import sofitel from "../../../ASSETS/tourisme/Image/image_loisirs/sofitel-abidjan-hotel.png";
import africa from "../../../ASSETS/tourisme/logo/logoAfrica.png";
import deluxe from "../../../ASSETS/tourisme/logo/Deluxe.png";
import france from "../../../ASSETS/tourisme/logo/Air-France-Logo.png";
import senegal from "../../../ASSETS/tourisme/logo/Air-Senegal.png";
import accor from "../../../ASSETS/tourisme/logo/logo-accor.jpg";
import coteIvoir from "../../../ASSETS/tourisme/logo/logo-air-cote-ivoire.jpg";
import ethiopie from "../../../ASSETS/tourisme/logo/logo-ethiopie.png";
import booking from "../../../ASSETS/tourisme/logo/logo-booking.png";
import qatar from "../../../ASSETS/tourisme/logo/logo-qatar.png";
import nova from "../../../ASSETS/tourisme/logo/logo-nova.png";

import Footer from "../../COMPONENTS/Footer/Footer";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Loading from "../../COMPONENTS/Loading/Loading";
import drapeau from "../../../ASSETS/tourisme/icone/ivory-coast.png";
import capitale from "../../../ASSETS/tourisme/icone/yamoussoukro.png";
import lieu from "../../../ASSETS/tourisme/icone/pin.png";
import SaintPaul from "../../../ASSETS/tourisme/Image/cathedralePaul.jpg";
import banco from "../../../ASSETS/tourisme/Image/banco.jpg";
import paradis from "../../../ASSETS/tourisme/Image/small-bathroom-with-modern-style-ai-generated.jpg";
import paradis2 from "../../../ASSETS/tourisme/Image/living-room-mid-century-style-with-warm-colors-ai-generative.jpg";
import paradis3 from "../../../ASSETS/tourisme/Image/luxury-bedroom-hotel.jpg";
import paradis5 from "../../../ASSETS/tourisme/Image/beautiful-shot-modern-house-kitchen.jpg";
import paradis6 from "../../../ASSETS/tourisme/Image/modern-kitchen-design-interior.jpg";
import paradis4 from "../../../ASSETS/tourisme/Image/3d-rendering-white-wood-living-room-near-bedroom-upstair.jpg";
import pin from "../../../ASSETS/CaImmigration/icones/pin.png";
import price from "../../../ASSETS/CaImmigration/icones/banknotes.png";
import { VscEye } from "react-icons/vsc";
import { IoIosArrowRoundForward } from "react-icons/io";
import Heber from "../../../API/tourisme/hebergement/index";
import Locat from "../../../API/tourisme/location/index";
import Restau from "../../../API/tourisme/restaurant/index";
import Tourisme from "../../../API/tourisme/lieu/index";
import Loisir from "../../../API/tourisme/loisir/index";
import { AnnoncesProps, CountryInfo, CurrencyInfo } from "../../../props";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { SearchContext } from "../../../SearchContext";
import { FaDollarSign, FaUser, FaUsers } from "react-icons/fa6";
import { ResultContext } from "../../../ResultContext";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";

export default function Home() {
  localStorage.setItem("url", JSON.stringify("/hometourisme"));
  localStorage.setItem("urlres",'/achats/billet_avion')


  const [heberge, setHeberge] = useState<AnnoncesProps[]>([]);
  const [location, setLocation] = useState<AnnoncesProps[]>([]);
  const [restaurant, setRestaurant] = useState<AnnoncesProps[]>([]);
  const [lieuTour, setLieu] = useState<AnnoncesProps[]>([]);
  const [loisir, setLoisir] = useState<AnnoncesProps[]>([]);
  const [country, setCountry] = useState<any>(null);
  const [info, setInfo] = useState<CountryInfo>({});
  const [curr, setCurr] = useState<CurrencyInfo>({});
  const {
    age,
    updateAge,
    arrivDate,
    departDate,
    adult,
    child,
    updateArrival,
    updateDepart,
    updateChild,
    updateAdult,
  } = React.useContext(SearchContext);
  const [showInfo, setShowInfo] = useState<Boolean>(true);
  const contexts = React.useContext(ResultContext);
  const [loading, setLoading] = useState(true);

  //console.log(age)

  let code = localStorage.getItem("code")
    ? localStorage.getItem("code")
    : localStorage.getItem("is_code");

  const getCountrySelected = async () => {
    if (code !== null) {
      await axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/api/country/information/${code}`
        )
        .then((res) => {
          if (res.data.status === 200) {
            setInfo(res.data.infoCountry);
            setCurr(res.data.currency);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log("Erreur lors de l'appel a l'API ", err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const getHomeHeber = () => {
    Heber.getHomeData(code)
      .then((res: any) => {
        //console.log(res)
        if (res.data.status === 200 && contexts?.results.hebergement === null) {
          setHeberge(res.data.donnee.slice(0, 3));
          setLoading(false);
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getHomeVoiture = () => {
    Locat.getHomeData(code)
      .then((res: any) => {
        if (res.data.status === 200 && contexts?.results.voiture === null) {
          //console.log(res);
          setLocation(res.data.data.slice(0, 3));
          setLoading(false);
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getHomeRestau = () => {
    Restau.getHomeData(code)
      .then((res: any) => {
        if (res.data.status === 200 && contexts?.results.resto === null) {
          //console.log(res);
          setRestaurant(res.data.data.slice(0, 4));
          setLoading(false);
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getHomeLieu = () => {
    Tourisme.getHomeData(code)
      .then((res: any) => {
        if (res.data.status === 200 && contexts?.results.culture === null) {
          setLieu(res.data.data.slice(0, 3));
          setLoading(false);
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getHomeLoisir = () => {
    Loisir.getHomeData(code)
      .then((res: any) => {
        if (res.data.status === 200 && contexts?.results.loisire === null) {
          //console.log(res);
          setLoisir(res.data.data.slice(0, 3));
          setLoading(false);
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getDefaultCountry = async () => {
    const apiKey = "d23bdc1cbe3649e8b2942516f6ecd4f2";

    try {
      setLoading(true); // Met le chargement à true au début de la requête

      // Effectuer la requête API
      const response = await fetch(
        `https://api.geoapify.com/v1/ipinfo?apiKey=${apiKey}`
      );

      if (!response.ok) {
        throw new Error(`Erreur HTTP : ${response.status}`);
      }
      const result = await response.json();
      //console.log("les information venant de", result.country)
      // Mettre à jour l'état avec le pays
      setCountry(result.country);
      localStorage.setItem("is_code", result.country.iso_code);
      //localStorage.setItem('code',result.country.iso_code)
      if (code === null) {
        //code = localStorage.getItem('code')
        setShowInfo(true);
        await axios
          .get(
            `${process.env.REACT_APP_BASE_URL}/api/country/default/information/${result.country.iso_code}`
          )
          .then((res) => {
            if (res.data.status === 200) {
              setInfo(res.data.infos);
              setCurr(res.data.currency);
              setLoading(false);
              //localStorage.setItem('code',result.country.iso_code)
            }
          })
          .catch((err) => {
            console.log("Erreur lors de l'appel a l'API ", err);
          });
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false); // Met fin à l'état de chargement
    }
  };

  const getCountryInfos = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/api/country/default/information/${code}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          //console.log(res.data.currency)

          setInfo(res.data.infos);
          setCurr(res.data.currency);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("Erreur lors de l'appel a l'API ", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const getPhotoCountry =async ()=>{
  //     await axios.get(`${process.env.REACT_APP_BASE_URL}/api/country/photo`,{
  //      params:{value}
  //     }).then((res)=>{
  //         if(res.data.status === 200){
  //          setPhoto(res.data.image)
  //         }
  //     }).catch((err)=>{
  //      console.log("Erreur lors de l'appel a l'API ",err)
  //     })
  //  }

  function truncate(str: any) {
    return str.length > 150 ? str.substring(0, 100) + "..." : str;
  }

  useEffect(() => {
    getHomeHeber();
    getHomeVoiture();
    getHomeRestau();
    getHomeLieu();
    getHomeLoisir();
    getDefaultCountry();
    getCountryInfos();
    getCountrySelected();
    //getPhotoCountry()
    /* const timer = setTimeout(() => {
            // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
            setLoading(false);
        }, 2000); // 5000 millisecondes = 5 secondes */

    // Nettoyer le timer si le composant est démonté avant la fin du délai
    //return () => clearTimeout(timer);
  }, [code]);

  useEffect(() => {
    if (
      contexts?.results.culture !== null ||
      contexts?.results.hebergement !== null ||
      contexts?.results.voiture !== null ||
      contexts?.results.resto !== null ||
      contexts?.results.loisire !== null
    ) {
      setLieu(contexts?.results.culture);
      setHeberge(contexts?.results.hebergement);
      setLocation(contexts?.results.voiture);
      setRestaurant(contexts?.results.resto);
      setLoisir(contexts?.results.loisire);
    }
  }, [
    contexts?.results.culture,
    contexts?.results.hebergement,
    contexts?.results.voiture,
    contexts?.results.resto,
  ]);

  const { t } = useTranslation() as { t: (key: string) => string };
  const lang = localStorage.getItem("langague");
  let pays = localStorage.getItem("pays");

  // useEffect(() => {
  //   if (
  //     contexts?.results.culture !== null ||
  //     contexts?.results.hebergement !== null ||
  //     contexts?.results.voiture !== null ||
  //     contexts?.results.resto !== null ||
  //     contexts?.results.loisire !== null
  //   ) {
  //     setLieu(contexts?.results.culture);
  //     setHeberge(contexts?.results.hebergement);
  //     setLocation(contexts?.results.voiture);
  //     setRestaurant(contexts?.results.resto);
  //     setLoisir(contexts?.results.loisire);
  //   }
  // }, [
  //   contexts?.results.culture,
  //   contexts?.results.hebergement,
  //   contexts?.results.voiture,
  //   contexts?.results.resto,
  // ]);
  

  let authUser: { userId: number } | null = JSON.parse(
    localStorage.getItem("data") || "null"
  );

  return (
    <div className="flex flex-col justify-center ">
      {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>
          {/* navbar */}
          <Navbar />
          <div>
            <ToastContainer />
          </div>
          {/* back image */}

          {info.description_image ? (
            <div
              className="relative z-0 flex flex-col items-center justify-center w-screen h-screen bg-center bg-no-repeat bg-cover"
              style={
                info.description_image
                  ? {
                      backgroundImage: `url('data:image/png;base64,${info.description_image}')`,
                    }
                  : {}
              }
            >
              <div className="flex flex-col items-center justify-center space-y-5 navbar_animation ">
                <div className="italic font-semibold text-white xs:text-3xl s:text-xl ">
                  {t("BIENVENUE")}
                </div>
                <div className="font-semibold text-white uppercase md:text-7xl xs:text-5xl s:text-3xl ">
                  {showInfo &&
                    (Object.keys(info).length > 0 &&
                    (info?.fr_Name || info?.Name)
                      ? lang === "fr"
                        ? info?.fr_Name
                        : info?.Name
                      : pays)}

                  {Object.keys(info).length === 0 &&
                    pays === null &&
                    (lang === "fr" ? country?.name_native : country?.name)}
                </div>
                <div className="italic font-semibold text-center text-white md:text-3xl xs:text-2xl s:text-xl ">
                  {info
                    ? info?.welcome_title
                    : t(
                        "pays d'émerveillement côtier et d'aventures inoubliables !"
                      )}
                </div>
              </div>
            </div>
          ) : (
            <Loading />
          )}

          {/* barre de recherche principale */}
          <div className="absolute inset-x-0 flex justify-center md:-bottom-20 s:-bottom-64 xs:-bottom-40">
            <BarresearchP cde={code ? code : country.iso_code} />
          </div>

          <div className="relative flex flex-col items-center justify-center md:mt-40 s:mt-80">
            {/* container1 */}

            <div className="flex items-center justify-center px-5 md:space-x-14 md:flex-row s:flex-col-reverse s:space-x-0">
              {info.fr_Name && (
                <>
                  <div className="flex flex-col pt-2 space-y-4 ">
                    <div className="uppercase titre_ci_home ">
                      {lang === "fr" ? info.fr_Name : info.Name}
                    </div>
                    <div className="md:w-[500px] xs:w-[700px] s:w-[260px] sm:w-[300px] pt-3 text-justify ">
                      {info.description_texte}
                    </div>
                    <span className="border-b-2 border-orange-400"></span>
                    <div className="flex items-center space-x-3">
                      <img
                        src={`data:image/png;base64,${info.Icon}`}
                        alt="drapeau"
                        className="w-8"
                      />
                      <div>
                        {" "}
                        <b>Devise : </b> {info.devise}
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <img src={capitale} alt="capitale" className="w-8" />
                      <div>
                        {" "}
                        <b>{t("Capitale")} : </b>
                        {info.capital}{" "}
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      {/* <img src={capitale} alt='capitale' className='w-8'/> */}
                      <FaDollarSign />
                      <div>
                        {" "}
                        <b>{t("Monnaire")} : </b>
                        {curr?.name} {curr?.sign}{" "}
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      {/* <img src={capitale} alt='capitale' className='w-8'/> */}
                      <FaUser size={20} color="black" />
                      <div>
                        {" "}
                        <b>{t("Président")} : </b>
                        {info.president}{" "}
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      {/* <img src={capitale} alt='capitale' className='w-8'/> */}
                      <FaUsers size={20} color="black" />
                      <div>
                        {" "}
                        <b>{t("Habitants")} : </b>
                        {info.population?.toLocaleString("fr-FR")}{" "}
                        {t("Habitants")}{" "}
                      </div>
                    </div>
                  </div>
                  <div>
                    <img
                      src={`data:image/png;base64,${info.description_image}`}
                      className="xs:w-[700px] md:w-[600px] s:w-[260px] sm:w-[300px] rounded-lg"
                      alt="Ci"
                    />
                  </div>
                </>
              )}
            </div>

            {/* container2 */}
            {lieuTour.length > 0 ? (
              <div className="flex flex-col items-center justify-center w-screen px-5 py-10 my-20 container2_home md:space-y-6 ">
                <div className="flex flex-col items-center justify-center pb-10 space-y-3 text-white">
                  <div className="md:text-3xl sm:text-xl">
                    {" "}
                    {t("Culture")} &{" "}
                    <span className="text-orange-400">{t("Découverte")},</span>
                  </div>
                  <div className="md:text-lg sm:text-lg ">
                    {t(
                      "Découvrez les différents sites touristiques à visités et diverses activités sur la plateforme"
                    )}
                  </div>
                </div>

                <div className="grid gap-8 pb-10 lg:grid-cols-4 md:grid-cols-3 xs:grid-cols-2 sm:grid-cols-1 ">
                  {lieuTour.map((data, index) => (
                    <div key={index} className="flex flex-col items-center">
                      {/* titre */}
                      <div className="flex items-center space-x-2 bg-[#FCCA46] py-2 pl-3 w-[250px] rounded-md relative top-12 md:right-9">
                        {/* icone */}
                        <img src={lieu} alt="lieu" className="w-6" />
                        {/* texte */}
                        <div className="text-sm text-white ">
                          {data.title_announce}
                        </div>
                       
                      </div>
                      {/* image du site touristique */}

                      <img
                        src={`data:image/png;base64,${data[0]}`}
                        alt={data.title_announce}
                        className="transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 
                                     duration-700 md:w-[350px] cursor-zoom-in  sm:w-[320px] h-[250px] 
                                     s:w-[260px] rounded-md rounded-tl-lg rounded-tr-lg"
                                     
                      />

                      {/* bloc blan description */}
                      <div className="md:w-[320px] rounded-md  sm:w-[300px] s:w-[260px] h-[250px]  bg-white p-5 relative bottom-12">
                        <div className="flex justify-between w-full ">
                            <div className="md:w-[280px] sm:w-[260px] s:w-[230px] ">
                              {truncate(data?.description_announce)}
                            </div>
                            <div className="text-xl font-semibold sm:text-sm s:text-xs">
                              {data.price_announce} FCFA
                            </div>
                        </div>
                       
                        <div className="grid mt-4 place-items-end">
                          <div className="flex justify-between w-full ">
                            {/* <Link to='/Reservation_Tourisme' state={data.id_announce}>
                                                                    <button className='flex items-center h-8 px-2 space-x-2 text-sm font-bold text-white transition-transform transform bg-orange-400 rounded active:scale-75'>
                                                                        <p>Reserver</p>
                                                                    </button>
                                                                </Link> */}
                            {authUser && authUser.userId !== data.made_by && (
                              <Link
                                to="/Reservation_Tourisme"
                                state={data.id_announce}
                              >
                                <button className="flex items-center h-8 px-2 space-x-2 text-sm font-bold text-white transition-transform transform bg-orange-400 rounded active:scale-75">
                                  <p>{t("Reserver")}</p>
                                </button>
                              </Link>
                            )}
                            {
                              <Link
                                to="/culture/Voir_Plus/#voir-plus"
                                state={data.id_announce}
                              >
                                <button className="flex items-center h-8 px-2 space-x-2 text-sm font-bold text-white transition-transform transform bg-orange-400 rounded active:scale-75">
                                  <p>{t("Voir plus")}</p>
                                  <VscEye className="text-lg" />
                                </button>
                              </Link>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <Link to="/culture">
                  <button className="flex items-center space-x-2 font-semibold bg-white rounded md:px-9 s:px-6 md:py-4 s:py-2 md:text-lg s:text-sm hover:bg-slate-800 hover:text-white ">
                    <p> {t("Decouvrir plus")}</p>
                    <IoIosArrowRoundForward className="text-xl" />
                  </button>
                </Link>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center w-screen px-5 py-10 my-20 container2_home md:space-y-6 ">
                <div className="flex flex-col items-center justify-center pb-10 space-y-3 text-white">
                  <div className="md:text-3xl sm:text-xl">
                    {" "}
                    {t("Culture")} &{" "}
                    <span className="text-orange-400">{t("Découverte")},</span>
                  </div>
                  <div className="md:text-3xl sm:text-xl">
                    {t(
                      "Désoler nous n'avons pas des cultures  de ce pays pour le moment"
                    )}
                  </div>
                </div>
                <Link to="/Dashboard/Publications/Culture_Decouverte/Ajouter_les_decouvertes">
                  <button className="flex flex-row items-center justify-center py-2 mt-20 space-x-2 font-medium text-yellow-400 border-2 border-yellow-400 rounded px-9 hover:bg-yellow-400 hover:text-white">
                    <p>{t("Ajouter un lieu Touristique")}</p>
                    <IoIosArrowRoundForward className="text-xl" />
                  </button>
                </Link>
              </div>
            )}

            <hr className="sm:w-80 md:w-96 " />

            {/* container3 */}
            {heberge.length > 0 ? (
              <div className="flex flex-col items-center px-5 my-20 space-y-16">
                <div className="flex flex-col items-center justify-center space-y-5">
                  <div className="text-orange-400 uppercase md:text-3xl sm:text-xl">
                    {" "}
                    {t("hébergements")}
                  </div>
                  <div className="  text-center s:w-[260px] sm:w-[340px] md:w-[850px] xs:w-[600px] text-lg">
                    {t(
                      "Découvrez le parfait équilibre entre confort et élégance avec nos résidences en location. Chaque espace a été soigneusement conçu pour créer une atmosphère accueillante, offrant un style de vie contemporain."
                    )}
                  </div>
                </div>

                <div className="grid gap-20 pt-5 mt-10 xs:grid-cols-2 md:grid-cols-3 sm:grid-cols-1">
                  {heberge.map((list, index) => (
                    <div key={index} className='flex flex-col w-full transition duration-300 ease-in-out delay-150 cursor-pointer hover:-translate-y-1 hover:scale-110 '>
                        <Link to="/hebergement/Voir_plus/#voir-plus" state={
                                        list.id_announce
                                        }>
                        {/* image de la residence */}
                        <img className='shadow-xl xs:w-72 s:w-64 xs:h-52 lg:h-60 s:h-40 ' src={`data:image/png;base64,${list[0]}`} alt={list.title_announce} />
                        {/* description */}
                        <div className=' xs:w-72  s:w-64  h-[350px] bg-white shadow-xl border-l-4 border-yellow-400 lg:space-y-4 s:space-y-0 px-3  '>
                        {list.status === "enabled" && (
                                    <div className='bg-[#3ec53e] text-white w-[90px] h-6 text-center relative bottom-6 md:left-[182px] xs:left-[119px] s:left-[150px] '>Disponible</div>
                                    )}
                                    {list.status === "disabled" && (
                                    <div className='bg-[#fc5151] text-white w-[90px] h-6 text-center relative bottom-6 md:left-[182px] xs:left-[119px] s:left-[150px]'>Réservé</div>
                                    )}

                            {/* lieu */}
                            <div className='flex items-center py-2 space-x-2'>
                                <img src={pin} className='w-4' alt='localisation'/>
                                <p className='font-thin '>{list?.contact_address}</p>
                            </div>

                            <p className='font-medium text-orange-400 md:text-sm lg:text-lg sm:text-sm s:text-xs'>{list.title_announce}</p>
                            <p className='font-light md:pb-3 sm:pb-2'>{truncate(list.description_announce)}</p>
                            <hr className='s:pb-1 lg:pb-0' />
                            {/* Prix */}
                            <div className='flex items-center pt-4 space-x-2'>
                            <img src={price} className='w-6' alt='prix'/>
                                <div className='text-lg font-semibold sm:text-sm s:text-xs'>{list.price_announce} FCFA / Nuit</div>
                            </div>
                            {list.status === "enabled" && authUser && authUser.userId !== list.made_by && (
                                    <Link to="/Reservation_Hebergement" state={
                                        list.id_announce
                                    } >
                                    <button className='bg-[#233D4D] text-white md:w-[200px] s:w-[170px] relative left-6 h-8  rounded
                                        justify-center cursor-pointer transition ease-in-out delay-150
                                        hover:-translate-y-1 hover:scale-110 duration-300 flex items-center space-x-2 mt-4 '>
                                        {t("Faire une reservation")}
                                    </button>
                                  </Link>
                             )}
                        </div>
                        </Link>
                    </div>

                  ))}
                </div>
                <Link to="/hebergement">
                  <button className="flex items-center justify-center py-2 mt-10 space-x-2 font-medium border-2 rounded border-slate-800 text-slate-800 px-9 hover:bg-slate-800 hover:text-white">
                    <p>{t("Voir plus")}</p>
                    <IoIosArrowRoundForward className="text-xl" />
                  </button>
                </Link>
              </div>
            ) : (
              <div className="flex flex-col items-center px-5 my-20 space-y-16">
                <div className="flex flex-col items-center justify-center space-y-5">
                  <div className="text-orange-400 uppercase md:text-3xl sm:text-xl">
                    {" "}
                    {t("hébergements")}
                  </div>
                  <div className="md:text-3xl sm:text-xl">
                    {t(
                      "Désoler nous n'avons pas des hebergements de ce pays pour le moment"
                    )}
                  </div>
                </div>
                <Link to="/Dashboard/Publications/Hebergement/Ajouter_des_hebergements">
                  <button className="flex flex-row items-center justify-center py-2 mt-20 space-x-2 font-medium text-yellow-400 border-2 border-yellow-400 rounded px-9 hover:bg-yellow-400 hover:text-white">
                    <p>{t("Ajouter un hébergement")}</p>
                    <IoIosArrowRoundForward className="text-xl" />
                  </button>
                </Link>
              </div>
            )}

            <hr className="sm:w-80 md:w-96 " />

            {/* container4 */}
            {restaurant.length > 0 ? (
              <div className="flex flex-col items-center justify-center px-8 my-20">
                <div className="flex flex-col items-center justify-center space-y-5 text-slate-800">
                  <p className="uppercase md:text-3xl sm:text-xl">
                    {t("restaurant")}
                  </p>
                  <p className="text-center s:w-[260px] sm:w-[340px] md:w-[850px] xs:w-[600px] text-lg">
                    {t(
                      "Savourez l'essence de la gastronomie dans nos restaurants uniques. Des saveurs exquises, une ambiance chaleureuse et un service exceptionnel vous attendent."
                    )}
                  </p>
                </div>

                <div className="grid pt-20 md:gap-16 s:gap-32 md:grid-cols-4 xs:grid-cols-2 s:grid-cols-1 ">
                  {restaurant.map((data, index) => (
                    <div
                      key={index}
                      className="flex flex-col items-center space-y-5 transition duration-300 ease-in-out delay-150 md:w-full s:w-48 hover:-translate-y-1 hover:scale-110"
                    >
                      <Link
                        to="/restaurants/Voir_Plus/#voir-plus"
                        state={data.id_announce}
                      >
                        <img
                          className="w-[320px] h-[200px] border-4 border-yellow-400 rounded-full shadow-xl "
                          src={`data:image/png;base64,${data[0]}`}
                          alt={data.title_announce}
                        />
                      </Link>
                      <p className="font-semibold uppercase md:text-base lg:text-lg s:text-base text-slate-800">
                        {data.title_announce}
                      </p>

                      <div className="flex flex-col text-center w-60 s:text-sm md:text-base lg:text-base">
                        <p className="font-medium text-orange-400">
                          {data.contact_address}
                        </p>
                        {truncate(data.description_announce)}
                      </div>

                      {data.status === "enabled" && (
                        <Link
                          to="/Reservation_Restaurant"
                          state={data.id_announce}
                        >
                          {authUser && authUser.userId !== data.made_by && (
                            <button className="px-8 py-2 text-white rounded bg-slate-800 hover:bg-white hover:border-2 hover:border-slate-800 hover:text-slate-800">
                              Réserver
                            </button>
                          )}
                        </Link>
                      )}
                    </div>
                  ))}
                </div>
                <Link to="/restaurants">
                  <button className="flex flex-row items-center justify-center py-2 mt-20 space-x-2 font-medium text-yellow-400 border-2 border-yellow-400 rounded px-9 hover:bg-yellow-400 hover:text-white">
                    <p> {t("Autres restaurants")}</p>
                    <IoIosArrowRoundForward className="text-xl" />
                  </button>
                </Link>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center w-screen px-5 py-10 my-20 container2_home md:space-y-6">
                <div className="flex flex-col items-center justify-center space-y-5 text-slate-800">
                  <p className="uppercase md:text-3xl sm:text-xl text-white">
                    {t("restaurant")}
                  </p>
                  <p className="text-center s:w-[260px] sm:w-[340px] md:w-[850px] xs:w-[600px] text-lg">
                    <div className="md:text-3xl sm:text-xl text-white">
                      {t(
                        "Désoler nous n'avons pas des restaurants de ce pays pour le moment"
                      )}
                    </div>
                  </p>
                </div>

                <Link to="/Dashboard/Publications/Restaurant/Ajouter_des_restaurants">
                  <button className="flex flex-row items-center justify-center py-2 mt-20 space-x-2 font-medium text-yellow-400 border-2 border-yellow-400 rounded px-9 hover:bg-yellow-400 hover:text-white">
                    <p> {t("Ajouter un restaurant")}</p>
                    <IoIosArrowRoundForward className="text-xl" />
                  </button>
                </Link>
              </div>
            )}

            <hr className="s:w-80 md:w-96 " />

            {/* container5 */}
            {location.length > 0 ? (
              <div className="flex flex-col items-center px-5 my-20">
                <div className="flex flex-col items-center justify-center space-y-5">
                  <p className="text-orange-400 uppercase md:text-3xl sm:text-xl">
                    {" "}
                    {t("location")}{" "}
                    <span className="text-slate-800"> {t("de véhicule")}</span>{" "}
                  </p>
                  <p className="text-center s:w-[260px] sm:w-[340px] md:w-[850px] xs:w-[600px] text-lg">
                    {t(
                      "Explorez la liberté de voyager à votre rythme avec notre service de location de véhicules. Des options variées, des tarifs compétitifs et un service client dévoué font de chaque trajet une aventure sans souci"
                    )}
                    .
                  </p>
                </div>

                <div className="grid gap-20 pt-5 mt-10 md:grid-cols-3 xs:grid-cols-2 sm:grid-cols-1">
                  {location.map((list, index) => (
                    <div
                      key={index}
                      className="flex flex-col transition duration-300 ease-in-out delay-150 cursor-pointer hover:-translate-y-1 hover:scale-110 "
                    >
                      {/* image de voiture */}
                      <Link
                        to="/Locationdevehicule/Voiture/#voir-plus"
                        state={list.id_announce}
                      >
                            <img
                              className="shadow-xl xs:w-72 sm:w-64 lg:h-60 sm:h-52 xs:h-52 rounded-tl-lg rounded-tr-lg"
                              src={`data:image/png;base64,${list[0]}`}
                              alt={list.title_announce}
                            />

                      </Link>
                      {/* bloc blanc description de la voiture */}
                      <div className="h-full px-4 pb-2 bg-white border-l-4 border-yellow-400 shadow-xl xs:w-72 sm:w-64 lg:space-y-2 sm:space-y-0">
                        <div className="flex items-center space-x-2 sm:text-xs">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16.52"
                            height="40.28"
                            viewBox="0 0 67.52 101.28"
                          >
                            <g id="localisation" transform="translate(-85.333)">
                              <path
                                id="Tracé_269"
                                data-name="Tracé 269"
                                d="M119.093,0A33.764,33.764,0,0,0,89.386,49.8l27.861,50.388a2.11,2.11,0,0,0,3.692,0L148.81,49.787A33.766,33.766,0,0,0,119.093,0Zm0,50.64a16.88,16.88,0,1,1,16.88-16.88A16.9,16.9,0,0,1,119.093,50.64Z"
                                fill="#233d4d"
                              />
                            </g>
                          </svg>
                          <div className="text-base font-thin ">
                            {list.contact_address}
                          </div>
                        </div>

                        <div className="font-medium text-orange-400 md:text-sm lg:text-lg sm:text-sm">
                          {list.title_announce}
                        </div>
                        <div className="font-light md:pb-2 sm:pb-2 sm:text-xs md:text-base">
                          {truncate(list?.description_announce)}
                        </div>
                        <hr className="sm:pb-1 lg:pb-0" />
                        {/* prix */}
                        <div className="flex items-center py-4 space-x-2 ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="27.742"
                            height="16.53"
                            viewBox="0 0 27.742 16.53"
                          >
                            <g
                              id="money"
                              transform="translate(-15.998 -112.999)"
                            >
                              <circle
                                id="Ellipse_29"
                                data-name="Ellipse 29"
                                cx="1.185"
                                cy="1.185"
                                r="1.185"
                                transform="translate(19.28 119.238)"
                                fill="#fe7f2d"
                              />
                              <path
                                id="Tracé_270"
                                data-name="Tracé 270"
                                d="M47.629,142,46,143.6v8.359l1.573,1.545h19.45l1.633-1.548V143.6L67.051,142Zm1.023,1.04h4.431a.289.289,0,0,1,0,.578H48.652a.289.289,0,0,1,0-.578Zm-1.289,0h.173a.289.289,0,0,1,0,.578h-.173a.289.289,0,0,1,0-.578Zm1.369,6.471a1.763,1.763,0,1,1,1.763-1.763A1.763,1.763,0,0,1,48.732,149.511ZM57.325,153a5.252,5.252,0,1,1,5.252-5.252A5.252,5.252,0,0,1,57.325,153Zm10.413-5.252a1.821,1.821,0,1,1-1.821-1.821A1.821,1.821,0,0,1,67.738,147.749Z"
                                transform="translate(-28.268 -27.325)"
                                fill="#fe7f2d"
                              />
                              <circle
                                id="Ellipse_30"
                                data-name="Ellipse 30"
                                cx="1.243"
                                cy="1.243"
                                r="1.243"
                                transform="translate(36.407 119.181)"
                                fill="#fe7f2d"
                              />
                              <path
                                id="Tracé_271"
                                data-name="Tracé 271"
                                d="M165.753,160.6a4.674,4.674,0,1,0,4.674,4.674A4.674,4.674,0,0,0,165.753,160.6Zm0,4.36a1.383,1.383,0,0,1,.291,2.735v.393a.289.289,0,0,1-.578,0V167.7a1.376,1.376,0,0,1-1.1-1.352.288.288,0,1,1,.577,0,.806.806,0,0,0,.8.8h.01a.805.805,0,0,0,0-1.61,1.383,1.383,0,0,1-.287-2.736v-.343a.289.289,0,0,1,.578,0v.343a1.373,1.373,0,0,1,1.093,1.352.29.29,0,1,1-.579,0,.805.805,0,1,0-.8.805Z"
                                transform="translate(-136.696 -44.85)"
                                fill="#fe7f2d"
                              />
                              <path
                                id="Tracé_272"
                                data-name="Tracé 272"
                                d="M41.659,127.445a1.364,1.364,0,0,0,.4-.989l-.175-12.094A1.39,1.39,0,0,0,40.493,113H17.39A1.376,1.376,0,0,0,16,114.391l.175,12.095a1.392,1.392,0,0,0,1.391,1.366h23.1A1.374,1.374,0,0,0,41.659,127.445Zm-2.79-.691H19.189a.28.28,0,0,1-.2-.083l-1.759-1.71a.281.281,0,0,1-.079-.208v-8.6a.281.281,0,0,1,.079-.207l1.81-1.764a.289.289,0,0,1,.2-.081H38.9a.282.282,0,0,1,.2.083l1.784,1.764a.284.284,0,0,1,.08.206v8.6a.285.285,0,0,1-.085.212l-1.813,1.709A.291.291,0,0,1,38.87,126.754Z"
                                transform="translate(0 0)"
                                fill="#fe7f2d"
                              />
                              <path
                                id="Tracé_273"
                                data-name="Tracé 273"
                                d="M73.22,142.331l.17,11.747a1.96,1.96,0,0,1-1.969,1.989H48.637a1.387,1.387,0,0,0,1.361,1.1H73.1a1.378,1.378,0,0,0,1.391-1.4l-.175-12.094A1.4,1.4,0,0,0,73.22,142.331Z"
                                transform="translate(-30.752 -27.637)"
                                fill="#fe7f2d"
                              />
                            </g>
                          </svg>
                          <p className="sm:text-xs md:text-base">
                            {" "}
                            Prix : {list.price_announce} FCFA / {t("jour")}
                          </p>
                        </div>
                        {authUser &&
                          authUser.userId !== list.made_by &&
                          list.status === "enabled" && (
                            <Link
                              to="/Reservation_Vehicule"
                              state={list.id_announce}
                            >
                              <button
                                className="bg-[#233D4D] text-white w-[200px] relative left-6 h-8  rounded
                                                            justify-center cursor-pointer transition ease-in-out delay-150
                                                            hover:-translate-y-1 hover:scale-110 duration-300 flex items-center space-x-2 "
                              >
                                {t("Faire une reservation")}
                              </button>
                            </Link>
                          )}
                      </div>
                    </div>
                  ))}
                </div>

                <Link to="/Locationdevehicule">
                  <button className="flex items-end justify-center py-2 mt-10 space-x-2 font-medium border-2 rounded border-slate-800 text-slate-800 px-9 hover:bg-slate-800 hover:text-white">
                    <p>{t("Voir plus")}</p>
                    <IoIosArrowRoundForward className="text-xl" />
                  </button>
                </Link>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center w-screen px-5 py-10 my-20 container2_home md:space-y-6">
                <div className="flex flex-col items-center justify-center space-y-5">
                  <p className="text-orange-400 uppercase md:text-3xl sm:text-xl">
                    {" "}
                    {t("location")}{" "}
                    <span className="text-white"> {t("de véhicule")}</span>{" "}
                  </p>
                  <p className="text-center s:w-[260px] sm:w-[340px] md:w-[850px] xs:w-[600px] text-lg">
                    <div className="md:text-3xl sm:text-xl text-white">
                      {t(
                        "Désoler nous n'avons pas de vehicule en location dans  ce pays pour le moment"
                      )}
                    </div>
                  </p>
                </div>

                <Link to="/Dashboard/Publications/Location_Vehicule/Ajouter_les_vehicules">
                  <button className="flex flex-row items-center justify-center py-2 mt-20 space-x-2 font-medium text-yellow-400 border-2 border-yellow-400 rounded px-9 hover:bg-yellow-400 hover:text-white">
                    <p>{t("Ajouter un vehicule")}</p>
                    <IoIosArrowRoundForward className="text-xl" />
                  </button>
                </Link>
              </div>
            )}

            {/* container6 */}
            <div className="grid w-screen my-20 container2_home s:p-10 sm:pb-32 s:pb-28 0 md:pb-10 s:px-5 s:gap-28 md:gap-8 lg:grid-cols-6 md:grid-cols-4 xs:grid-cols-2 sm:grid-cols-1 place-content-center place-items-center">
              <div className="space-y-4 ">
                <div className="text-white uppercase ">
                  <span className="text-yellow-400 mr-2">
                    {t("les activités en")}
                  </span>
                  {showInfo &&
                    (Object.keys(info).length > 0 &&
                    (info?.fr_Name || info?.Name)
                      ? lang === "fr"
                        ? info?.fr_Name
                        : info?.Name
                      : pays)}

                  {Object.keys(info).length === 0 &&
                    pays === null &&
                    (lang === "fr" ? country?.name_native : country?.name)}
                </div>
                <div className="text-justify text-white sm:w-72 s:w-60 md:text-base sm:text-sm">
                  {t(
                    "Des excursions culturelles aux aventures en plein air, plongez dans une expérience vibrante. Que vous soyez passionné d'histoire, amateur de nature ou en quête d'émotions fortes, notre sélection d'activités vous promet des moments inoubliables pendant votre séjour"
                  )}
                </div>
              </div>

              {loisir.length !== 0 ? loisir.map((liste, index) => (
                <div
                key={index}
                className="relative flex flex-col overflow-hidden transition ease-in-out delay-150 cursor-pointer rounded-md w-full max-w-xs mx-auto"
              >
                <div className="w-full relative">
                  <img
                    className="w-[320px] h-[200px] object-cover rounded-md"
                    src={`data:image/png;base64,${liste[0]}`}
                    alt="botanique"
                  />
                  <div className="absolute bottom-0 right-0 bg-black bg-opacity-50 text-white p-2 rounded-tl-md">
                    <div className="font-bold text-center">
                      {liste.price_announce} FCFA
                    </div>
                  </div>
                </div>
                <div className="w-full bg-orange-400 text-white p-2 flex justify-between items-center">
                  <div>{liste.title_announce}</div>
                  {authUser && authUser.userId !== liste?.made_by && (
                    <div>
                      <Link to="/Reservation_Loisirs" state={liste.id_announce}>
                        Réserver
                      </Link>
                    </div>
                  )}
                </div>
               </div>
              )):(
                  <Link to="/Dashboard/Publications/Loisirs_activites/Voir_des_activites">
                  <button className="flex flex-row items-center justify-center py-2 mt-20 space-x-2 font-medium text-yellow-400 border-2 border-yellow-400 rounded px-9 hover:bg-yellow-400 hover:text-white">
                    <p>Ajouter une activité</p>
                    <IoIosArrowRoundForward className="text-xl" />
                  </button>
                </Link>
              )
             }
            </div>

            {/* partenaires */}
            <div className="flex flex-col items-center justify-center w-full">
              <div className="pb-8 font-medium uppercase md:text-2xl sm:text-lg text-neutral-800">
                {t("nos partenaires")}
              </div>
              <hr className="sm:w-80 md:w-96 w-full" />
              <div className=" px-5 w-full">
                <div className=" mx-auto">
                  <div className="flex items-center justify-center w-full h-full mb-2  sm:py-8 px-4 border-1 border-orange-400">
                    {/* Carousel for desktop and large size devices */}
                    <CarouselProvider
                      className="md:block hidden"
                      naturalSlideWidth={100}
                      naturalSlideHeight={100}
                      isIntrinsicHeight={true}
                      totalSlides={12}
                      visibleSlides={4}
                      step={1}
                      infinite={true}
                      isPlaying={true} // Active l'auto-slide
                      interval={3000}
                    >
                      <div className="w-full relative flex items-center justify-center">
                        <ButtonBack
                          role="button"
                          aria-label="slide backward"
                          className="absolute z-30 left-0 ml-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer"
                          id="prev"
                        >
                          <svg
                            width={8}
                            height={14}
                            viewBox="0 0 8 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7 1L1 7L7 13"
                              stroke="white"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </ButtonBack>
                        <div className="w-full h-full mx-auto overflow-x-hidden overflow-y-hidden">
                          <Slider>
                            <div
                              id="slider"
                              className="h-full flex lg:gap-8 md:gap-6 gap-14 items-center justify-start transition ease-out duration-700"
                            >
                              <Slide index={0}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={deluxe}
                                    alt="black chair and white table"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={1}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={africa}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                
                                </div>
                              </Slide>
                              <Slide index={2}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={france}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                  
                                </div>
                              </Slide>
                              <Slide index={3}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={qatar}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={4}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={senegal}
                                    alt="black chair and white table"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={5}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={nova}
                                    alt="black chair and white table"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={0}>
                              <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                <img
                                  src={ethiopie}
                                  alt="black chair and white table"
                                  className="object-cover object-center w-full"
                                />
                              </div>

                              </Slide>
                              <Slide index={1}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={booking}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={2}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={accor}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                
                                </div>
                              </Slide>
                              <Slide index={3}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={coteIvoir}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={4}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={qatar}
                                    alt="black chair and white table"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={5}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={deluxe}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                </div>
                              </Slide>
                            </div>
                          </Slider>
                        </div>
                        <ButtonNext
                          role="button"
                          aria-label="slide forward"
                          className="absolute z-30 right-0 mr-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
                          id="next"
                        >
                          <svg
                            width={8}
                            height={14}
                            viewBox="0 0 8 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1L7 7L1 13"
                              stroke="white"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </ButtonNext>
                      </div>
                    </CarouselProvider>

                    {/* Carousel for tablet and medium size devices */}
                    <CarouselProvider
                      className="md:hidden xs:block hidden"
                      naturalSlideWidth={100}
                      naturalSlideHeight={100}
                      isIntrinsicHeight={true}
                      totalSlides={12}
                      visibleSlides={2}
                      step={1}
                      infinite={true}
                      isPlaying={true} // Active l'auto-slide
                      interval={3000}
                    >
                      <div className="w-full relative flex items-center justify-center">
                        <ButtonBack
                          role="button"
                          aria-label="slide backward"
                          className="absolute z-30 left-0 ml-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer"
                          id="prev"
                        >
                          <svg
                            width={8}
                            height={14}
                            viewBox="0 0 8 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7 1L1 7L7 13"
                              stroke="white"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </ButtonBack>
                        <div className="w-full h-full mx-auto overflow-x-hidden overflow-y-hidden">
                          <Slider>
                            <div
                              id="slider"
                              className="h-full flex lg:gap-8 md:gap-6 gap-14 items-center justify-start transition ease-out duration-700"
                            >
                              <Slide index={0}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={deluxe}
                                    alt="black chair and white table"
                                    className="object-cover object-center w-full"
                                  />
                                </div>
                              </Slide>
                              <Slide index={1}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={africa}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                  
                                </div>
                              </Slide>
                              <Slide index={2}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={france}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={3}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={qatar}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={4}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={nova}
                                    alt="black chair and white table"
                                    className="object-cover object-center w-full"
                                  />
                                  
                                </div>
                              </Slide>
                              <Slide index={5}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={ethiopie}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                </div>
                              </Slide>
                              <Slide index={0}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={accor}
                                    alt="black chair and white table"
                                    className="object-cover object-center w-full"
                                  />
                                  
                                </div>
                              </Slide>
                              <Slide index={1}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={booking}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={2}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={deluxe}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={3}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={senegal}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={4}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={coteIvoir}
                                    alt="black chair and white table"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={5}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={deluxe}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                
                                </div>
                              </Slide>
                            </div>
                          </Slider>
                        </div>
                        <ButtonNext
                          role="button"
                          aria-label="slide forward"
                          className="absolute z-30 right-0 mr-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
                          id="next"
                        >
                          <svg
                            width={8}
                            height={14}
                            viewBox="0 0 8 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1L7 7L1 13"
                              stroke="white"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </ButtonNext>
                      </div>
                    </CarouselProvider>

                    {/* Carousel for mobile and Small size Devices */}
                    <CarouselProvider
                      className="block xs:hidden "
                      naturalSlideWidth={100}
                      naturalSlideHeight={100}
                      isIntrinsicHeight={true}
                      totalSlides={12}
                      visibleSlides={1}
                      step={1}
                      infinite={true}
                      isPlaying={true} // Active l'auto-slide
                      interval={3000}
                    >
                      <div className="w-full relative flex items-center justify-center">
                        <ButtonBack
                          role="button"
                          aria-label="slide backward"
                          className="absolute z-30 left-0 ml-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 cursor-pointer"
                          id="prev"
                        >
                          <svg
                            width={8}
                            height={14}
                            viewBox="0 0 8 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7 1L1 7L7 13"
                              stroke="white"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </ButtonBack>
                        <div className="w-full h-full mx-auto overflow-x-hidden overflow-y-hidden">
                          <Slider>
                            <div
                              id="slider"
                              className="h-full w-full flex lg:gap-8 md:gap-6 items-center justify-start transition ease-out duration-700"
                            >
                              <Slide index={0}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={deluxe}
                                    alt="black chair and white table"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={1}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={africa}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={2}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={qatar}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                  
                                </div>
                              </Slide>
                              <Slide index={3}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={senegal}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={4}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={ethiopie}
                                    alt="black chair and white table"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={5}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={france}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>

                              <Slide index={0}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={coteIvoir}
                                    alt="black chair and white table"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={1}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={accor}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                  
                                </div>
                              </Slide>
                              <Slide index={2}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={booking}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={3}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={nova}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                
                                </div>
                              </Slide>
                              <Slide index={4}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={senegal}
                                    alt="black chair and white table"
                                    className="object-cover object-center w-full"
                                  />
                                 
                                </div>
                              </Slide>
                              <Slide index={5}>
                                <div className="flex flex-shrink-0 relative w-full sm:w-auto">
                                  <img
                                    src={deluxe}
                                    alt="sitting area"
                                    className="object-cover object-center w-full"
                                  />
                                  
                                </div>
                              </Slide>
                            </div>
                          </Slider>
                        </div>
                        <ButtonNext
                          role="button"
                          aria-label="slide forward"
                          className="absolute z-30 right-0 mr-8 focus:outline-none focus:bg-gray-400 focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
                          id="next"
                        >
                          <svg
                            width={8}
                            height={14}
                            viewBox="0 0 8 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1L7 7L1 13"
                              stroke="white"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </ButtonNext>
                      </div>
                    </CarouselProvider>
                    
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </>
      )}
    </div>
  );
}
